<template lang="pug">
section.fit-referrals.card
  TableTitle(title="Referral Modules")
    template(#actions)
      BaseBtn.x-lg.blue(
        href="#",
        @click.prevent="openModuleSettingsOverlay()"
      ) ADD NEW
  .table.table--hoverable
    .th
      .td(@click.prevent="changeListOrder('ModuleName', fetchReferralModules)" style="cursor: pointer;") MODULE NAME
          i(style="font-weight: bolder;") {{ ModuleNameColumnSortingIcon }}
      .td Number of Provider Groups USING
      .td ACTIVE
    .tr(
      v-for="item in referralModules",
      :key="item.id",
      @click="openModuleSettingsOverlay(item.id)"
    )
      .td.bold {{item.moduleTitle}}
      .td {{item.numberOfProviderGroupsUsing}}
      .td
        base-icon(:name="item.isModuleEnabled === true ? 'yes' : 'no'")
  Pagination(
    v-if="pagination",
    @changePagination="changePagination"
    :pagination="pagination",
    :reloadFn="fetchReferralModules"
  )
  ReferralModulesSettingsOverlay(
    :key="`${componentKey}-1`",
    :moduleId="moduleId",
    :isOpen="isModuleSettingsOverlayOpen",
    @closeModuleSettingsOverlay="closeModuleSettingsOverlay",
    @reloadReferralModules="fetchReferralModules"
  )
</template>

<script>
import { defineComponent } from "vue";
import TableTitle from "@/components/TableTitle.vue";
import listPagesMixin from "@/mixins/listPagesMixin";
import Pagination from "@/components/Pagination.vue";
import ReferralModulesSettingsOverlay from "@/components/system-settings/overlays/ReferralModulesSettingsOverlay.vue";

import { fetchReferralModules } from "@/api/referralModulesApi";
import sortReferralModules from "@/mixins/sortReferralModules";

export default defineComponent({
  components: {
    TableTitle,
    Pagination,
    ReferralModulesSettingsOverlay,
  },
  mixins: [listPagesMixin, sortReferralModules],

  data() {
    return {
      isModuleSettingsOverlayOpen: false,
      referralModules: null,
      moduleId: null,
    };
  },

  methods: {
    async fetchReferralModules() {
      const order = this.listOrder
        ? {
            by: this.listOrder.by,
            direction: this.listOrder.direction,
          }
        : null;
      try {
        const res = await fetchReferralModules({
          params: {
            ...this.reqPagination,
            order,
          },
        });
        this.referralModules = res.data.referralModules;
        this.pagination = res.data.pagination;
      } catch (err) {
        console.error(err);
      }
    },
    openModuleSettingsOverlay(moduleId) {
      this.forceRerender();
      this.moduleId = moduleId ?? null;
      this.isModuleSettingsOverlayOpen = true;
    },
    closeModuleSettingsOverlay() {
      this.isModuleSettingsOverlayOpen = false;
    },
  },
  created() {
    this.fetchReferralModules();
  },
});
</script>

<style scoped lang="scss">
.td {
  &:nth-child(1) {
    width: math.percentage(math.div(458, $tabContentCardWidth));
  }
  &:nth-child(2) {
    width: math.percentage(math.div(458, $tabContentCardWidth));
  }
  &:last-child {
    width: math.percentage(math.div(262, $tabContentCardWidth));
    display: flex;
    justify-content: flex-end;
  }
}
</style>
